import { useQuery } from "react-query";
import axios from "infra/http";
import { VinculoAreaComum } from "../typings";

function useAreaComumVinculadas(params: { tenantId: string; id: string }) {
  return useQuery(
    `/v1/tenants/${params.tenantId}/area-comum/${params.id}/vinculos`,
    async () => {
      const { data } = await axios.get<VinculoAreaComum[]>(
        `/v1/tenants/${params.tenantId}/area-comum/${params.id}/vinculos`,
        {
          params,
        }
      );

      return data;
    }
  );
}

export default useAreaComumVinculadas;
